'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { VercelToolbar } from '@vercel/toolbar/next';
/**
 * Vercel Toolbar component for development
 *
 * Automatically shows in development mode only.
 * Can be explicitly enabled/disabled via the `enabled` prop.
 *
 * @example
 * ```tsx
 * // app/layout.tsx
 * import { VercelToolbar } from '@sandstone/dev-tools/vercel-toolbar';
 *
 * export default function RootLayout({ children }) {
 *   return (
 *     <html>
 *       <body>
 *         {children}
 *         <VercelToolbar />
 *       </body>
 *     </html>
 *   );
 * }
 * ```
 */
export function VercelToolbarComponent({ enabled, ...props }) {
    const shouldShow = enabled ?? process.env.NODE_ENV === 'development';
    if (!shouldShow) {
        return null;
    }
    return _jsx(VercelToolbar, { ...props });
}
